import { render } from "./CounterLayout2.vue?vue&type=template&id=31a2d9f3&scoped=true"
import script from "./CounterLayout2.vue?vue&type=script&lang=js"
export * from "./CounterLayout2.vue?vue&type=script&lang=js"

import "./CounterLayout2.vue?vue&type=style&index=0&id=31a2d9f3&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a2d9f3"]])

export default __exports__